import { queryOptions } from '@tanstack/react-query'
import { getConnectors } from '@/features/connectors'

export const connectorsQueries = {
  all: () => ['connectors'],
  lists: () => [...connectorsQueries.all(), 'list'],
  list: () =>
    queryOptions({
      queryKey: [...connectorsQueries.lists()],
      queryFn: () => getConnectors(),
    }),
}
